import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';
const root = `${configs.BACKEND_URL}/api/upwork/actions`;
export async function upworkAction(path = '', method = 'GET', body, signal) {
  const res = await fetchWithTenant(`${root}${path}`, { method, signal, ...(body ? { body: JSON.stringify(body) } : {}) });
  const result = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(result.message || 'Unable to load Upwork approvals.');
  return result.data;
}
